export default "__VITE_ASSET__BLzOh2sW__"